import { Params, ParamMap } from '@angular/router';

const JOB_KEY = 'job';

interface JobIdArg {
	jobId?: number;
}

export const toJobParams = (args: JobIdArg): Params =>
	args.jobId
		? {
				[JOB_KEY]: args.jobId ? args.jobId : undefined,
		  }
		: undefined;

export const toJobListArgs = (paramMap: ParamMap): JobIdArg =>
	paramMap.has(JOB_KEY)
		? {
				jobId: +paramMap.get(JOB_KEY),
		  }
		: undefined;
